<template>
    <Paper class="process-barcode">
        <el-tabs
            class="process-barcode-tabs"
            v-model="activeName"
            @tab-remove="removeTab"
        >
            <el-tab-pane name="List" :closable="false">
                <span slot="label">条码流向列表</span>
                <List @goDetail="goDetail"></List>
            </el-tab-pane>
            <el-tab-pane
                v-for="item in editableTabs"
                :name="item.barcodeNo"
                :key="item.barcodeNo"
                :closable="true"
            >
                <span slot="label">条码详情{{ item.barcodeNo.slice(-4) }}</span>
                <Detail :barcodeNo="item.barcodeNo"></Detail>
            </el-tab-pane>
        </el-tabs>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import List from './Components/List/Index';
import Detail from './Components/Detail/Index';
export default {
    name: 'processSearchNew',
    components: { Paper, List, Detail },
    data() {
        return {
            activeName: 'List',
            editableTabs: []
        };
    },
    methods: {
        goDetail(row) {
            const falg = this.editableTabs.some((item) => {
                return item.barcodeNo === row.barcodeNo;
            });
            if (!falg) this.editableTabs.push(row);
            this.activeName = row.barcodeNo;
        },
        removeTab(targetName) {
            this.editableTabs = this.editableTabs.filter(
                (item) => item.barcodeNo !== targetName
            );
            this.activeName = 'List';
        }
    }
};
</script>
<style lang="less" scoped>
.process-barcode {
    position: relative;
    height: calc(100vh - 70px);
    overflow: auto;
    padding-bottom: 0;
    padding-top: 0;
    /deep/ .el-tabs__content {
        overflow: unset;
        max-height: none;
    }
    /deep/ .el-tab-pane{
        max-height: none;
    }
    /deep/ .layout-content{
        padding-top: 0;
    }
}

</style>
